import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// `field` indica la chiave del documento traduzioni da aggiornare (default 'description';
// usato anche per 'servicesIncluded' nel wizard di prenotazione). `id` è la lingua (en/fr/de).
const QuillTranslationTextarea = ({ initContent, setInputData, id, field = 'description' }) => {
    const [quillContent, setQuillContent] = useState('');
    useEffect(() => {
        setInputData(prevState => ({
            ...prevState,
            [field]: {
                ...prevState[field],
                [id]: quillContent
            }
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quillContent])

    const [isFirstDone, setIsForstDone] = useState(false);
    useEffect(() => {
        if (initContent && !isFirstDone) {
            setQuillContent(initContent);
            setIsForstDone(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initContent])
    return (
        <ReactQuill value={quillContent} onChange={setQuillContent} />
    )
}

export default QuillTranslationTextarea;